export default {
    version: '0.0.1',
    schema: '0.0.1',
    configuration: {
        boilerplate: {
            initial: 15,
        },
    },
};
